import { CircularProgress, Grid } from "@mui/material"
import React, { useState } from "react"
import Vista from "../../components/Vista"
import { ChecklistStyles } from "../../utils/styles"
import Selector from "./Selector"
import AvanceOrdenServicio from "./AvanceOrdenServicio"
import OrdenServicio from "../jac/OrdenServicioUnidad"
import EficienciaMecanicos from "./EficienciaMecanicos"
import FrecuenciaVisitas from "./FrecuenciaVisitas"
import ConsumoRefacciones from "./ConsumoRefacciones"

let vs = ChecklistStyles()
const Index = ({ match }) => {
  const [screen, setScreen] = useState("OrdenServicioUnidad")
  const [loading, setLoading] = useState(false)
  let ChecklistStyles = vs()

  const renderScreen = () => {
    switch (screen) {
      case "OrdenServicio":
        return <OrdenServicio />
      case "AvanceOrdenServicio":
        return <AvanceOrdenServicio />
      case "EficienciaMecanicos":
        return <EficienciaMecanicos />
      case "FrecuenciaVisitas":
        return <FrecuenciaVisitas />
      case "ConsumoRefacciones":
        return <ConsumoRefacciones />
      default:
        return (
          <Grid
            container
            spacing={2}
            sx={{ p: 2, display: "flex", flexDirection: "column" }}
          >
            <Grid item>
              <h2>Seleccione un tipo de reporte</h2>
            </Grid>
          </Grid>
        )
    }
  }

  return (
    <Vista style={{ display: "block", backgroundColor: "#FFFFFF" }}>
      {!loading ? (
        <>
          <div className={ChecklistStyles.optionsContainer}>
            <Selector setScreen={setScreen} screen={screen} />
          </div>
          {renderScreen()}
        </>
      ) : (
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            "@media (min-width: 600px)": {
              margin: "100px"
            }
          }}
        >
          <CircularProgress />
        </Grid>
      )}
    </Vista>
  )
}

export default Index
